export default __webpack_public_path__ + "static/media/0393.5ef95dd8.jpg";